export default __webpack_public_path__ + "static/media/group-11@2xNew.2d2def6d.png";